import Store from 'store/store';
import pendingPromise from 'utils/pendingPromise';
import {
	DEFAULT_DEMO_DATA_DOMAIN,
	CMS_API_DEMO_DOMAIN,
	CMS_API_STAGE_DOMAIN,
	CMS_API_PROD_DOMAIN,
} from 'utils/constants';

const cache = new Map();

const qs = new URLSearchParams(typeof location !== 'undefined' ? location.search : '');
export const previewMode = qs.has('cms-preview');

// Resolved lazily because Store.appData isn't populated when this module first loads.
// Prod uses location.origin (or appData.meta.url as a fallback for non-browser contexts).
// Demo/local resolves to the matching region's demo domain.
function getDataDomain() {
	if (__IS_LOCAL__ || __IS_DEMO__) {
		if (qs.has('prod')) return Store.get().appData?.meta?.url || '';
		return Store.get().appData?.options?.demoDomain || DEFAULT_DEMO_DATA_DOMAIN;
	}
	return typeof window !== 'undefined' ? location.origin : (Store.get().appData?.meta?.url || '');
}

function getCmsApiDomain() {
	if (__IS_LOCAL__ || __IS_DEMO__) return CMS_API_DEMO_DOMAIN;
	const isStage = typeof window !== 'undefined' && location.host.startsWith('stage.');
	return isStage ? CMS_API_STAGE_DOMAIN : CMS_API_PROD_DOMAIN;
}

let previewDataWaitlist = {};
async function waitForPreviewData(name) {
	let promise = pendingPromise();
	previewDataWaitlist[name] ||= [];
	previewDataWaitlist[name].push(promise);
	return promise;
}

if (previewMode) {
	window.addEventListener('message', e => {
		let message = e.data;
		if (message?.type === 'data' && previewDataWaitlist[message.name]) {
			previewDataWaitlist[message.name].forEach(p => p.resolve(message.data));
			previewDataWaitlist[message.name] = [];
		}
	}, false);
}

async function getDataRaw(name, type = 'section') {
	if (previewMode && window.parent !== window) {
		window.parent.postMessage({ type: 'requestData', name }, '*');
		let data = await waitForPreviewData(name);
		if (data !== null) return data;
	}

	try {
		const url = name === 'all' && type === 'movie'
			? 'cms/movies/all/'
			: `cms/${type}s/${name}.json`;
		const res = await fetch(new URL(url, getDataDomain()));
		if (!res.ok) {
			throw new Error(`Data unavailable for ${name}`);
		}
		return await res.json();
	} catch {}

	return null;
}

export async function getData(name, type) {
	const cleanType = type === 'movie' ? 'movie' : 'section';
	const cacheId = `${cleanType}-${name}`;
	if (cache.has(cacheId)) {
		return cache.get(cacheId);
	}
	const promise = getDataRaw(name, cleanType);
	cache.set(cacheId, promise);
	return promise;
}

export async function cmsRequest(path, qs) {
	// return { data: [{ id: '0a40633b-6556-49c1-b36b-1db9863154dd', thundr_id: 1234 }, { id: '1a40633b-6556-49c1-b36b-1db9863154de' }] };
	const url = new URL(path, getCmsApiDomain());
	if (qs) {
		url.search = new URLSearchParams(qs).toString();
	}
	const res = await fetch(url);
	if (!res.ok) {
		throw new Error(res.status);
	}
	return await res.json();
}